import {
  CREATED,
  GEOCODE_FAILED,
  GEOCODE_FAILED_PICKUP,
  GEOCODE_FAILED_DROPOFF,
  GEOCODED,
  ASSIGNED,
  PICKUP_EN_ROUTE,
  PICKUP_DELAY,
  CANCELLED_BEFORE_PICKUP,
  PICKUP_READY,
  PICKUP_FAILED,
  PICKUP_SUCCEEDED,
  DROPOFF_EN_ROUTE,
  DROPOFF_DELAY,
  CANCELLED_AFTER_PICKUP,
  DROPOFF_READY,
  DROPOFF_FAILED,
  DROPOFF_SUCCEEDED,
  RETURN_EN_ROUTE,
  RETURN_DELAY,
  RETURN_READY,
  RETURN_FAILED,
  RETURN_SUCCEEDED
} from './shipmentStatus'

export const statusMap = {
  [CREATED]: "CREATED",
  [GEOCODE_FAILED]: "ERRORED",
  [GEOCODE_FAILED_PICKUP]: "ERRORED",
  [GEOCODE_FAILED_DROPOFF]: "ERRORED",
  [GEOCODED]: "CREATED",
  [ASSIGNED]: "ASSIGNED",
  [PICKUP_EN_ROUTE]: "ON TIME",
  [PICKUP_DELAY]: "DELAYED",
  [CANCELLED_BEFORE_PICKUP]: "CANCELLED",
  [PICKUP_READY]: "ON TIME",
  [PICKUP_FAILED]: "FAILED",
  [PICKUP_SUCCEEDED]: "ON TIME",
  [DROPOFF_EN_ROUTE]: "ON TIME",
  [DROPOFF_DELAY]: "DELAYED",
  [CANCELLED_AFTER_PICKUP]: "CANCELLED",
  [DROPOFF_READY]: "ON TIME",
  [DROPOFF_FAILED]: "FAILED",
  [DROPOFF_SUCCEEDED]: "COMPLETED",
  [RETURN_EN_ROUTE]: "RETURNING",
  [RETURN_DELAY]: "RETURNING",
  [RETURN_READY]: "RETURNING",
  [RETURN_FAILED]: "FAILED",
  [RETURN_SUCCEEDED]: "RETURNED",
};